/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Daterangepicker_To2Inputs */

const id_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ke`)
};

const ms_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ke`)
};

const da_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Til`)
};

const de_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bis`)
};

const en_us2_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To`)
};

const es_es2_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasta`)
};

const es_mx2_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasta`)
};

const fil_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanggang`)
};

const fr_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Au`)
};

const it_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A`)
};

const hu_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ig`)
};

const nl_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tot`)
};

const no_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Til`)
};

const pl_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do`)
};

const pt_br2_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To`)
};

const pt_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Até`)
};

const ro_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Până la`)
};

const fi_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päättyen`)
};

const sv_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Till`)
};

const vi_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đến`)
};

const tr_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitiş`)
};

const cs_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do`)
};

const bg_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`До`)
};

const ru_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`До`)
};

const uk_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`До`)
};

const ar_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إلى`)
};

const hi_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तक`)
};

const th_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถึง`)
};

const ja_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了`)
};

const zh_cn2_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结束`)
};

const zh_hant1_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To`)
};

const ko_components_daterangepicker_to2 = /** @type {(inputs: Components_Daterangepicker_To2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`종료`)
};

/**
* | output |
* | --- |
* | "To" |
*
* @param {Components_Daterangepicker_To2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_daterangepicker_to2 = /** @type {((inputs?: Components_Daterangepicker_To2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Daterangepicker_To2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_daterangepicker_to2(inputs)
	if (locale === "ms") return ms_components_daterangepicker_to2(inputs)
	if (locale === "da") return da_components_daterangepicker_to2(inputs)
	if (locale === "de") return de_components_daterangepicker_to2(inputs)
	if (locale === "en-US") return en_us2_components_daterangepicker_to2(inputs)
	if (locale === "es-ES") return es_es2_components_daterangepicker_to2(inputs)
	if (locale === "es-MX") return es_mx2_components_daterangepicker_to2(inputs)
	if (locale === "fil") return fil_components_daterangepicker_to2(inputs)
	if (locale === "fr") return fr_components_daterangepicker_to2(inputs)
	if (locale === "it") return it_components_daterangepicker_to2(inputs)
	if (locale === "hu") return hu_components_daterangepicker_to2(inputs)
	if (locale === "nl") return nl_components_daterangepicker_to2(inputs)
	if (locale === "no") return no_components_daterangepicker_to2(inputs)
	if (locale === "pl") return pl_components_daterangepicker_to2(inputs)
	if (locale === "pt-BR") return pt_br2_components_daterangepicker_to2(inputs)
	if (locale === "pt") return pt_components_daterangepicker_to2(inputs)
	if (locale === "ro") return ro_components_daterangepicker_to2(inputs)
	if (locale === "fi") return fi_components_daterangepicker_to2(inputs)
	if (locale === "sv") return sv_components_daterangepicker_to2(inputs)
	if (locale === "vi") return vi_components_daterangepicker_to2(inputs)
	if (locale === "tr") return tr_components_daterangepicker_to2(inputs)
	if (locale === "cs") return cs_components_daterangepicker_to2(inputs)
	if (locale === "bg") return bg_components_daterangepicker_to2(inputs)
	if (locale === "ru") return ru_components_daterangepicker_to2(inputs)
	if (locale === "uk") return uk_components_daterangepicker_to2(inputs)
	if (locale === "ar") return ar_components_daterangepicker_to2(inputs)
	if (locale === "hi") return hi_components_daterangepicker_to2(inputs)
	if (locale === "th") return th_components_daterangepicker_to2(inputs)
	if (locale === "ja") return ja_components_daterangepicker_to2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_daterangepicker_to2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_daterangepicker_to2(inputs)
	return ko_components_daterangepicker_to2(inputs)
});
export { components_daterangepicker_to2 as "components.dateRangePicker.to" }